<template>
  <posts-show />
</template>

<script>
import PostsShow from 'theme/components/core/blocks/Wordpress/press/Show'
import { isServer } from '@vue-storefront/core/helpers'

export default {
  name: 'PostsPageShow',
  components: { PostsShow },
  beforeRouteEnter (to, from, next) {
    if (isServer) {
      next()
    } else {
      next(vm => {
        vm.$store.commit('ui/routeChanged', { to: to, from: from })
      })
    }
  }
}
</script>

<style scoped>
  /* Always export scoped styles to not break the app */
</style>
